import React from 'react';
import SABadge from '../../components/SuperAdmin/SABadge';
import SAPermPill from '../../components/SuperAdmin/SAPermPill';
import '../../assets/styles/SuperAdmin/SATheme.css';
import '../../assets/styles/SuperAdmin/SAPermMatrix.css';

const SAPermMatrix = ({ perms, SA_MODULES, SA_ROLES, handlePermChange, onSave }) => {
    const categories = [...new Set(SA_MODULES.map(m => m.cat))];

    return (
        <div className="animate-in">
            <div style={{ 
                position: 'sticky', 
                top: 0, 
                zIndex: 100, 
                background: 'var(--sa-bg)', 
                paddingBottom: 20,
                marginBottom: 20,
                borderBottom: '1px solid var(--sa-border)'
            }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, fontFamily: "'Sora'" }}>Permission Matrix</h2>
                        <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--sa-muted)" }}>Set privileges per role: None (hidden), Read (view only), Write, Full. Click pills to change, then Save to store in DB.</p>
                    </div>
                    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                        <SABadge color="green">FULL</SABadge>
                        <SABadge color="orange">WRITE</SABadge>
                        <SABadge color="blue">READ</SABadge>
                        <span style={{ background: "var(--sa-bg)", color: "var(--sa-dim)", border: "1px solid var(--sa-border)", padding: "3px 10px", borderRadius: 6, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>NONE</span>
                        <div style={{ width: 1, height: 20, background: "var(--sa-border)", margin: "0 4px" }} />
                        <button onClick={onSave} style={{ background: "var(--sa-green)", color: "#fff", border: "none", padding: "8px 20px", borderRadius: 8, fontWeight: 700, fontSize: 12, cursor: "pointer", fontFamily: "'DM Sans'" }}>💾 Save</button>
                    </div>
                </div>
            </div>

            <div className="sa-matrix-container" style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
                <div className="sa-matrix-header" style={{ 
                    gridTemplateColumns: `170px repeat(${SA_ROLES.length}, 1fr)`,
                    position: 'sticky',
                    top: 0,
                    background: 'var(--sa-card)',
                    zIndex: 9,
                    paddingBottom: 12,
                    paddingTop: 12,
                    borderBottom: '2px solid var(--sa-border)'
                }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: "var(--sa-dim)", textTransform: "uppercase", letterSpacing: "0.08em" }}>Module</div>
                    {SA_ROLES.map(r => (
                        <div key={r.id} style={{ textAlign: "center" }}>
                            <div style={{ fontSize: 15 }}>{r.icon}</div>
                            <div style={{ fontSize: 9, fontWeight: 800, color: r.color, marginTop: 2 }}>{r.name}</div>
                        </div>
                    ))}
                </div>

                {categories.map(cat => (
                    <div key={cat}>
                        <div className="sa-matrix-cat-row" style={{ color: cat === "Super Admin" ? "var(--sa-red)" : "var(--sa-dim)" }}>
                            {cat === "Super Admin" && "🔒 "}{cat}
                        </div>
                        {SA_MODULES.filter(m => m.cat === cat).map(mod => (
                            <div key={mod.id} className="sa-matrix-row" style={{ gridTemplateColumns: `170px repeat(${SA_ROLES.length}, 1fr)` }}>
                                <div style={{ fontSize: 12, fontWeight: 500, color: mod.id === "roles_priv" ? "var(--sa-red)" : "var(--sa-text)", display: "flex", alignItems: "center", gap: 5 }}>
                                    {mod.id === "roles_priv" && "🛡️ "}{mod.name}
                                </div>
                                {SA_ROLES.map(r => (
                                    <div key={r.id} style={{ textAlign: "center" }}>
                                        <SAPermPill
                                            level={perms[r.id]?.[mod.id] || "none"}
                                            onChange={lvl => handlePermChange(r.id, mod.id, lvl)}
                                            locked={r.locked || (mod.id === "roles_priv" && r.id !== "super_admin")}
                                        />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SAPermMatrix;
